/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEntitlementResponse
 */
export interface UserEntitlementResponse {
    /**
     * 
     * @type {string}
     * @memberof UserEntitlementResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntitlementResponse
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof UserEntitlementResponse
     */
    quantityLimit?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UserEntitlementResponse
     */
    startsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserEntitlementResponse
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntitlementResponse
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntitlementResponse
     */
    sourceRef?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntitlementResponse
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntitlementResponse
     */
    effective: boolean;
}

/**
 * Check if a given object implements the UserEntitlementResponse interface.
 */
export function instanceOfUserEntitlementResponse(value: object): value is UserEntitlementResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('effective' in value) || value['effective'] === undefined) return false;
    return true;
}

export function UserEntitlementResponseFromJSON(json: any): UserEntitlementResponse {
    return UserEntitlementResponseFromJSONTyped(json, false);
}

export function UserEntitlementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEntitlementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'quantityLimit': json['quantityLimit'] == null ? undefined : json['quantityLimit'],
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'source': json['source'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'active': json['active'],
        'effective': json['effective'],
    };
}

export function UserEntitlementResponseToJSON(json: any): UserEntitlementResponse {
    return UserEntitlementResponseToJSONTyped(json, false);
}

export function UserEntitlementResponseToJSONTyped(value?: UserEntitlementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'quantityLimit': value['quantityLimit'],
        'startsAt': value['startsAt'] == null ? value['startsAt'] : value['startsAt'].toISOString(),
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'source': value['source'],
        'sourceRef': value['sourceRef'],
        'active': value['active'],
        'effective': value['effective'],
    };
}

